export class GetReservationsByUserRequestModel {
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public venueId: string;
  public userEmail: string;
}
